/* Jquery */
var $ = require("jquery");

function cart() {

    $(".cart__item__delete").click(function() {
        console.log('click')
        var parent_id = $(this).parent().parent().parent();
        parent_id.fadeOut();

        console.log(parent_id);
    })
}

export default cart;

//////////////////////////////////////////////////

